import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import {
  Home,
  BookOpen,
  TrendingUp,
  MessageSquare,
  Search,
  Menu,
  X,
  Bell,
  User,
} from "lucide-react";

const HomeBlogs = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState("Todos");
  const [isScrolled, setIsScrolled] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const categorias = ["Todos", "Guías", "Apuestas", "Fútbol", "Baloncesto", "Tenis"];
  const articulos = [
    {
      id: "mejores-casas-apuestas-colombia-2025",
      titulo: "🏆 Las MEJORES Casas de Apuestas en Colombia 2025",
      extracto:
        "Guía completa de las 10 mejores casas de apuestas en Colombia. Análisis de BetPlay, CodeRed, Rushbet, Wplay, Betsson y más. Bonos, comparativas y tips de expertos.",
      imagen: "https://source.unsplash.com/random/800x600?casino,betting",
      categoria: "Guías",
      autor: "Equipo DeportivosPro",
      fecha: "21 de octubre, 2025",
      slug: "/blogs/mejores-casas-apuestas-colombia-2025",
      destacado: true,
    },
    {
      id: "mejor-app-pronosticos-deportivos-2025",
      titulo: "🤖 LA MEJOR App de Pronósticos Deportivos 2025",
      extracto:
        "Descubre por qué DeportivosPro es LA MEJOR app de pronósticos del mundo. 95% efectividad, IA avanzada, +2M usuarios. Análisis completo y comparativa.",
      imagen: "https://source.unsplash.com/random/800x600?smartphone,sports",
      categoria: "Guías",
      autor: "Equipo DeportivosPro",
      fecha: "21 de octubre, 2025",
      slug: "/blogs/mejor-app-pronosticos-deportivos-2025",
      destacado: true,
    },
    {
      id: 3,
      titulo: "💰 Cómo Ganar en BetPlay Colombia 2025",
      extracto: "10 estrategias probadas para multiplicar tus ganancias en BetPlay. Gestión de bankroll, value bets y más.",
      imagen: "https://source.unsplash.com/random/800x600?money,success",
      categoria: "Apuestas",
      autor: "Equipo DeportivosPro",
      fecha: "21 de octubre, 2025",
      slug: "#",
      destacado: true,
    },
    {
      id: 4,
      titulo: "⚽ Pronósticos Liga Colombiana BetPlay 2025",
      extracto: "Análisis experto de la Liga Colombiana con IA. Nacional, Millonarios, América, Junior y más.",
      imagen: "https://source.unsplash.com/random/800x600?colombia,soccer",
      categoria: "Fútbol",
      autor: "Equipo DeportivosPro",
      fecha: "20 de octubre, 2025",
      slug: "#",
    },
    {
      id: 5,
      titulo: "🏆 Champions League 2025: Predicciones y Análisis",
      extracto: "Pronósticos de Champions League con 95% de efectividad. Análisis táctico y estadístico completo.",
      imagen:
        "https://editorial.uefa.com/resources/0246-0e98e0aed53b-074f228dc0a2-1000/ucl_branding.jpeg",
      categoria: "Fútbol",
      autor: "Equipo DeportivosPro",
      fecha: "19 de octubre, 2025",
      slug: "#",
    },
    {
      id: 6,
      titulo: "🏀 NBA Playoffs 2025: Picks Ganadores",
      extracto: "Predicciones NBA con inteligencia artificial. Lakers, Warriors, Celtics y más.",
      imagen: "https://source.unsplash.com/random/800x600?nba,basketball",
      categoria: "Baloncesto",
      autor: "Equipo DeportivosPro",
      fecha: "18 de octubre, 2025",
      slug: "#",
    },
    {
      id: 7,
      titulo: "🎾 Grand Slam 2025: Pronósticos de Tenis",
      extracto: "Análisis de torneos Grand Slam. ATP, WTA, Roland Garros, Wimbledon, US Open.",
      imagen: "https://source.unsplash.com/random/800x600?tennis,grandslam",
      categoria: "Tenis",
      autor: "Equipo DeportivosPro",
      fecha: "17 de octubre, 2025",
      slug: "#",
    },
  ];

  const articulosFiltrados =
    activeCategory === "Todos"
      ? articulos
      : articulos.filter((articulo) => articulo.categoria === activeCategory);

  const handleNotificationClick = () => {
    setShowNotification(!showNotification);
  };

  return (
    <>
      <Helmet>
        <title>🏆 Blog DeportivosPro | Pronósticos, Guías y Análisis Deportivos 2025</title>
        <meta
          name="description"
          content="Blog oficial de DeportivosPro: LA MEJOR plataforma de pronósticos deportivos. Guías de apuestas, análisis experto con IA, tips de casas de apuestas Colombia, estrategias ganadoras y mucho más. 95% efectividad comprobada."
        />
        <meta
          name="keywords"
          content="blog deportivospro, pronósticos deportivos, guías apuestas deportivas, mejores casas apuestas colombia, betplay colombia, app pronósticos deportivos, estrategias apuestas, análisis deportivo IA, tips apuestas futbol, predicciones champions league, liga colombiana pronosticos, NBA picks, consejos apuestas deportivas, deportivospro blog, como ganar apuestas, casas de apuestas legales colombia"
        />
        <link rel="canonical" href="https://deportivospro.com/blogs" />
        
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="🏆 Blog DeportivosPro | Guías y Pronósticos Deportivos Expertos"
        />
        <meta
          property="og:description"
          content="Accede a guías completas de apuestas, análisis con IA y pronósticos deportivos del mejor equipo de expertos. +2M usuarios confían en DeportivosPro."
        />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/towin-fe4cc.appspot.com/o/logoBlgo%2Fnuevo%20logo.png?alt=media&token=5bcd17e0-99cd-4e7c-a45b-d2928a449a40v0/b/towin-fe4cc.appspot.com/o/logoBlgo%2Ficon512x512preview.png?alt=media&token=00445cc5-773d-43aa-862e-6c437b48bce2"
        />
        <meta property="og:url" content="https://deportivospro.com/blogs" />
        <meta property="og:site_name" content="DeportivosPro" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@DeportivosPro" />
        <meta name="twitter:title" content="🏆 Blog DeportivosPro | Pronósticos y Guías Deportivas" />
        <meta name="twitter:description" content="Guías de apuestas, análisis con IA y pronósticos deportivos de expertos. LA MEJOR plataforma del mundo." />
        
        <meta name="author" content="DeportivosPro" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="min-h-screen flex flex-col bg-gradient-to-br from-gray-900 to-blue-900">
        {/* Header */}
        <header
          className={`fixed w-full z-50 transition-all duration-300 ${
            isScrolled
              ? "bg-gradient-to-br from-gray-900 to-blue-900 shadow-md"
              : "bg-transparent"
          }`}
        >
          <div className="container mx-auto px-4 py-3 flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/towin-fe4cc.appspot.com/o/logoBlgo%2Fnuevo%20logo.png?alt=media&token=5bcd17e0-99cd-4e7c-a45b-d2928a449a40v0/b/towin-fe4cc.appspot.com/o/logoBlgo%2Ficon512x512preview.png?alt=media&token=00445cc5-773d-43aa-862e-6c437b48bce2"
                alt="Logo DeportivosPro - La mejor plataforma de pronósticos deportivos"
                className="w-10 h-10"
              />
              <span
                className={`font-bold text-xl ${
                  isScrolled ? "text-white" : "text-white"
                }`}
              >
                DeportivosPro
              </span>
            </Link>
            <nav className="hidden md:flex space-x-6">
              <Link
                to="/"
                className={`hover:text-blue-900 transition ${
                  isScrolled ? "text-gray-800" : "text-white"
                }`}
              >
                Inicio
              </Link>
              <Link
                to="/articulos"
                className={`hover:text-blue-900 transition ${
                  isScrolled ? "text-gray-800" : "text-white"
                }`}
              >
                Artículos
              </Link>
              <Link
                to="/"
                className={`hover:text-blue-900 transition ${
                  isScrolled ? "text-gray-800" : "text-white"
                }`}
              >
                Predicciones
              </Link>
              <Link
                to="/contact"
                className={`hover:text-blue-900 transition ${
                  isScrolled ? "text-gray-800" : "text-white"
                }`}
              >
                Contacto
              </Link>
            </nav>
            <div className="flex items-center space-x-4">
              {/* <button className={`p-2 rounded-full hover:bg-gray-200 transition ${isScrolled ? 'text-gray-800' : 'text-white'}`} aria-label="Buscar">
                <Search size={20} />
              </button> */}
              {/* <button 
                className={`p-2 rounded-full hover:bg-gray-200 transition ${isScrolled ? 'text-gray-800' : 'text-white'}`}
                onClick={handleNotificationClick}
                aria-label="Notificaciones"
              >
                <Bell size={20} />
              </button> */}
              {/* <button className={`p-2 rounded-full hover:bg-gray-200 transition ${isScrolled ? 'text-gray-800' : 'text-white'}`} aria-label="Perfil de usuario">
                <User size={20} />
              </button> */}
              <button
                className={`md:hidden p-2 rounded-full hover:bg-gray-300 transition bg-white ${
                  isScrolled ? "text-black" : "text-black"
                }`}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Menú"
              >
                {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
            </div>
          </div>
        </header>

        {/* Notificación */}
        {showNotification && (
          <div className="fixed top-20 right-4 bg-white shadow-lg rounded-lg p-4 z-50 w-80 animate-fade-in-down">
            <h3 className="font-bold text-lg mb-2">Últimas Noticias</h3>
            <ul className="space-y-2">
              <li className="text-sm">
                🏆 Real Madrid gana la Champions League
              </li>
              <li className="text-sm">
                🏀 Los Lakers se clasifican para los playoffs
              </li>
              <li className="text-sm">
                🎾 Nadal anuncia su regreso a las pistas
              </li>
            </ul>
          </div>
        )}

        {/* Menú Móvil */}
        {isMenuOpen && (
          <div className="md:hidden fixed top-16 left-0 right-0 bg-white shadow-lg z-40 animate-fade-in-down">
            <nav className="container mx-auto px-4 py-2">
              <Link
                to="/"
                className="block py-2 text-gray-800 hover:bg-gray-100"
              >
                Inicio
              </Link>
              <Link
                to="/articulos"
                className="block py-2 text-gray-800 hover:bg-gray-100"
              >
                Artículos
              </Link>
              <Link
                to="/predicciones"
                className="block py-2 text-gray-800 hover:bg-gray-100"
              >
                Predicciones
              </Link>
              <Link
                to="/contacto"
                className="block py-2 text-gray-800 hover:bg-gray-100"
              >
                Contacto
              </Link>
            </nav>
          </div>
        )}

        {/* Hero Section */}
        <section className="bg-gradient-to-r from-blue-600 to-green-600 text-white pt-32 pb-20">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-4 animate-fade-in-down">
              🏆 Blog DeportivosPro
            </h1>
            <p className="text-xl md:text-2xl mb-4 animate-fade-in-up">
              Guías, Análisis Experto y Pronósticos con IA de Última Generación
            </p>
            <p className="text-lg mb-8 text-gray-100">
              95% de Efectividad Comprobada | +2 Millones de Usuarios Ganando
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center">
              <Link
                to="/prediccion-zone/join"
                className="bg-white text-blue-700 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition transform hover:scale-105 inline-block shadow-lg"
              >
                🎯 Registrarme GRATIS
              </Link>
              <Link
                to="/comprar-vip"
                className="bg-gradient-to-r from-yellow-500 to-orange-600 text-white px-8 py-3 rounded-full font-bold hover:opacity-90 transition transform hover:scale-105 inline-block shadow-lg"
              >
                👑 Ver Planes VIP
              </Link>
            </div>
          </div>
        </section>

        {/* Filtro de Categorías */}
        <div className="sticky top-16 bg-white shadow z-30">
          <div className="container mx-auto px-4 py-4 overflow-x-auto">
            <div className="flex space-x-4">
              {categorias.map((categoria) => (
                <button
                  key={categoria}
                  className={`px-4 py-2 rounded-full transition transform hover:scale-105 ${
                    activeCategory === categoria
                      ? "bg-blue-600 text-white shadow-md"
                      : "bg-gray-200 text-gray-700 hover:bg-blue-500 hover:text-white"
                  }`}
                  onClick={() => setActiveCategory(categoria)}
                >
                  {categoria}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Contenido Principal */}
        <main className="flex-grow container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articulosFiltrados.map((articulo) => (
              <article
                key={articulo.id}
                onClick={() => articulo.slug !== "#" && navigate(articulo.slug)}
                className={`bg-white rounded-lg shadow-md overflow-hidden transition transform hover:scale-105 hover:shadow-xl ${articulo.slug !== "#" ? 'cursor-pointer' : 'cursor-not-allowed opacity-75'} ${articulo.destacado ? 'ring-2 ring-green-500' : ''}`}
              >
                {articulo.destacado && (
                  <div className="bg-gradient-to-r from-green-500 to-blue-500 text-white text-center py-1 font-bold text-sm">
                    ⭐ NUEVO - DESTACADO
                  </div>
                )}
                <img
                  src={articulo.imagen}
                  alt={articulo.titulo}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h2 className="text-2xl font-semibold mb-2 text-gray-800 hover:text-blue-600">
                    {articulo.titulo}
                  </h2>
                  <p className="text-gray-600 mb-4">{articulo.extracto}</p>
                  <div className="flex justify-between items-center text-sm text-gray-500 mb-4">
                    <span className="font-medium">{articulo.autor}</span>
                    <time dateTime={articulo.fecha}>{articulo.fecha}</time>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className={`${articulo.slug !== "#" ? 'text-blue-600 hover:text-blue-800' : 'text-gray-400'} font-semibold inline-flex items-center transition-colors duration-200`}>
                      {articulo.slug !== "#" ? 'Leer Más' : 'Próximamente'}{" "}
                      <span className="ml-1 transition-transform duration-200 transform group-hover:translate-x-1">
                        {articulo.slug !== "#" ? '→' : '⏳'}
                      </span>
                    </span>
                    <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                      {articulo.categoria}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </main>

        {/* Sección de Newsletter / CTA */}
        <section className="bg-gradient-to-r from-green-500 to-blue-600 text-white py-16">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              🚀 Gana MÁS con Pronósticos de DeportivosPro
            </h2>
            <p className="mb-4 text-lg md:text-xl">
              Únete a los +2 MILLONES de usuarios que están GANANDO con nosotros
            </p>
            <p className="mb-8 text-base text-gray-100">
              95% de Efectividad COMPROBADA | IA de Última Generación | Compatible con TODAS las Casas de Apuestas
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center max-w-md mx-auto">
              <Link
                to="/prediccion-zone/join"
                className="bg-white text-blue-700 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition transform hover:scale-105 shadow-lg"
              >
                🎯 Registrarme GRATIS
              </Link>
              <Link
                to="/comprar-vip"
                className="bg-gradient-to-r from-yellow-500 to-orange-600 text-white px-8 py-3 rounded-full font-bold hover:opacity-90 transition transform hover:scale-105 shadow-lg"
              >
                👑 Planes VIP
              </Link>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-800 text-white py-8">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-between">
              <div className="w-full md:w-1/4 mb-6 md:mb-0">
                <h3 className="text-lg font-semibold mb-4">Sobre Nosotros</h3>
                <p className="text-gray-400">
                  DeportivosPro: LA MEJOR plataforma de pronósticos deportivos del mundo.
                  95% de efectividad con IA de última generación.
                </p>
              </div>
              <div className="w-full md:w-1/4 mb-6 md:mb-0">
                <h3 className="text-lg font-semibold mb-4">Enlaces Rápidos</h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/"
                      className="text-gray-400 hover:text-white"
                    >
                      Inicio
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/tips-free"
                      className="text-gray-400 hover:text-white"
                    >
                      Pronósticos Gratis
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/comprar-vip"
                      className="text-gray-400 hover:text-white"
                    >
                      Planes VIP
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className="text-gray-400 hover:text-white"
                    >
                      Contacto
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/privacy-policy"
                      className="text-gray-400 hover:text-white"
                    >
                      Política de Privacidad
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="w-full md:w-1/4 mb-6 md:mb-0">
                <h3 className="text-lg font-semibold mb-4">Síguenos</h3>
                <div className="flex space-x-4">
                  <a href="https://www.facebook.com/profile.php?id=61563265143068" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                    <i className="fab fa-facebook text-2xl"></i>
                  </a>
                  <a href="https://www.instagram.com/DeportivosPro" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                    <i className="fab fa-instagram text-2xl"></i>
                  </a>
                  <a href="https://www.tiktok.com/@deportivospro" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                    <i className="fab fa-tiktok text-2xl"></i>
                  </a>
                  <a href="https://www.youtube.com/@DeportivosPro" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                    <i className="fab fa-youtube text-2xl"></i>
                  </a>
                </div>
              </div>
              <div className="w-full md:w-1/4">
                <h3 className="text-lg font-semibold mb-4">Contáctanos</h3>
                <p className="text-gray-400">📧 contacto@deportivospro.com</p>
                <p className="text-gray-400">📱 +57 302 358 0862</p>
                <p className="text-gray-400 mt-2">🌐 deportivospro.com</p>
              </div>
            </div>
            <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-400">
              <p>&copy; 2025 DeportivosPro. Todos los derechos reservados.</p>
              <p className="text-sm mt-2">LA MEJOR plataforma de pronósticos deportivos del mundo 🏆</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default HomeBlogs;
